export default __webpack_public_path__ + "static/Egg_Incubator-297966282da4e2d5d55007418f74daf0.png";